"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rambda_1 = require("rambda");
/**
 * Checks if an input is empty
 * @param {object} obj - object to be checked against undefined or null
 * @returns true if undefined, null,  "" or {} else false
 */


function isEmpty(obj) {
  if (obj === undefined || obj === null) {
    return true;
  } else if (typeof obj === 'string') {
    return obj.trim() === '';
  } else if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.every(function (item) {
        return isEmpty(item);
      });
    }

    return Object.keys(obj).every(function (key) {
      return isEmpty(obj[key]);
    });
  } else if (typeof obj === 'number') {
    return false;
  }

  return obj === undefined;
}

exports.isEmpty = isEmpty;
/**
 * Returns an object from a query string
 * @param {string} qs query string to be converted to an object
 * @returns {object|undefined}
 */

function queryStringToObject(qs) {
  if (!qs) {
    return;
  }

  var kvs = qs.replace('?', '').split('&').map(function (kv) {
    return kv.split('=');
  });
  var result = {};
  kvs.forEach(function (kv) {
    result[kv[0]] = kv[1];
  });
  return result;
}

exports.queryStringToObject = queryStringToObject;
/**
 * Returns an query string, takes an object as input
 * @param {object} obj - An object to be converted to query string
 * @returns {string|undefined} string or undefined
 */

function objectToQueryString(obj) {
  if (!obj) {
    return;
  }

  return Object.keys(obj).map(function (k) {
    return obj[k] !== undefined && obj[k] !== null && obj[k] !== '' ? k + "=" + obj[k] : '';
  }).filter(function (i) {
    return !!i;
  }).join('&');
}

exports.objectToQueryString = objectToQueryString;
/**
 * Groups an array of objects into a object
 * @param {string} key object key to be used as grouping parameter
 * @param {Array<any>} array array of objects to be grouped by the key
 * @param {(any)=>any} transform optional - this function will transform each object being added to a group
 */

function groupByValueInKey(key, array // transform?: (obj: any) => any
) {
  return rambda_1.groupBy(function (obj) {
    return (obj[key] || 'null').toString();
  }, array); // if (array && array.length) {
  //   const id = array[0][key];
  //   if (transform) {
  //     result[id] = array.map(d => transform(d));
  //   } else {
  //     result[id] = array;
  //   }
  // }
  // return result;
}

exports.groupByValueInKey = groupByValueInKey;
/**
 * Combines two arrays resulting in an array with elements present
 * exclusively in arr1 and arr2
 * @param {Array<any>} arr1
 * @param {Array<any>} arr2
 */

exports.diffArray = function (arr1, arr2) {
  if (!arr1 && !arr2) {
    return [];
  }

  return arr1.filter(function (el) {
    return !arr2.includes(el);
  }).concat(arr2.filter(function (el) {
    return !arr1.includes(el);
  }));
};
/**
 * Takes an array of objects and tries to find the given object in the array
 * using a matcher function. If the object is found, the object in the array
 * is updated with the given object
 * @param array1 Array of objects
 * @param obj Object to be updated / merged
 * @param matcher Should return true if item1 and item2 are the same, else false
 */


function updateObjectInArray(array1, obj, matcher) {
  return array1.map(function (item) {
    if (!matcher(item, obj)) {
      // This isn't the item we care about - keep it as-is
      return item;
    } // Otherwise, this is the one we want - return an updated value


    return __assign({}, item, obj);
  });
}

exports.updateObjectInArray = updateObjectInArray;
/**
 * Counts distinct values in an array of objects for an given object key
 * @example
 * // returns 1
 * const arr = [
 *      { id: 1, text: "item 1" },
 *      { id: 1, text: "item 2" },
 *      { id: 1, text: "item 3" }
 *    ];
 *
 * return countDistinctBy(arr, "id");
 * @param {Array<any>} a Array of objects
 * @param {string} key keyof object in the array
 */

function countDistinctBy(a, key) {
  if (!a || !a.length) {
    return 0;
  }

  var result = 0;
  var temp = new Set();

  for (var _i = 0, a_1 = a; _i < a_1.length; _i++) {
    var obj = a_1[_i];

    if (obj && obj[key]) {
      var val = obj[key];

      if (!temp.has(val)) {
        result += 1;
        temp.add(val);
      }
    }
  }

  return result;
}

exports.countDistinctBy = countDistinctBy;
/**
 * Takes an arrray of objects and returns unique values given a predicate function
 * If not predicate function is given, uses strict object comparision (===)
 * @param a Array of objects
 * @param pred Function to be used for uniqueness comparision
 */

function distinct(a, pred) {
  if (pred === void 0) {
    pred = function pred(x, y) {
      return x === y;
    };
  }

  if (!a || !a.length) {
    return a;
  }

  return rambda_1.uniqWith(pred, a);
}

exports.distinct = distinct;
/**
 * Takes a function and debounces calls to this function, waiting given milliseconds
 * to call the function
 * @param func Function to be debounced
 * @param wait Time for wait in millisseconds
 */

function debounce(func, wait) {
  var timeout;
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var context = this;

    var functionCall = function functionCall() {
      return func.apply(context, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, wait || 200);
  };
}

exports.debounce = debounce;